function resistanceHome() {

    $('.glitch').on('mouseenter', function(){
        var el = $(this);
        el.removeClass('hover');
    });
    setTimeout(function(){
        $('.glitch.carl.hover').removeClass('hover');
        $('.glitch.adam').addClass('hover');
    }, 3500);
    setTimeout(function(){
        $('.glitch.carl').addClass('hover');
        $('.glitch.adam.hover').removeClass('hover');
    }, 7000);
    setTimeout(function(){
        $('.glitch.carl').removeClass('hover');
        $('.glitch.adam').addClass('hover');
    }, 10500);
    setTimeout(function(){
        $('.glitch.adam.hover').removeClass('hover');
    }, 14000);

    $('#re-oc').on('click', function(){
        var el = $(this);
        el.toggleClass('active');
        $('#re-nav').fadeToggle(300);
        $('body').toggleClass('re-oc-open');
    });

    //$('#re-oc').trigger('click');

    var $resistanceHomeLocations = $('.resistance-home-locations li');
    if($resistanceHomeLocations.length) {
        ddLog('Using $resistanceHomeLocations in resistance-2020.js');
        getEventJSON()
        .done(function(data) {

            var objectarray = '';

            $resistanceHomeLocations.each(function(event,index){
                var el = $(this);
                var event = el.data('event');
                var output = '';

                $.each( data, function( key, val ) {

                    if (event == val.code) {

                        var current_url = `${window.location.protocol}//${window.location.hostname}`;

                        output += '<a class="rel"';

                        if( val.url != '') {
                            output += `href="${val.url}" target="_blank">`;
                        } else {
                            output += '>';
                        }

                        if( val.title != '') {
                            output += `<em>${val.title}</em>`;
                        }

                        if( val.date.label != '') {
                            val.date.label = val.date.label.replace("—", "&nbsp;/&nbsp;");
                            output += `<i><img src="${val.media.flag ?? ultra_settings.images.default_flag}" class="flag" height="10"> ${val.date.label}</i>`;
                        }

                        output += '</a><span class="lbreak3"></span>';
                    }
                });
                el.html(output);
            });
        });
    }
}
